export const ACTION_IDLE = 'idle';
export const ACTION_PENDING = 'pending';
export const ACTION_SUCCEEDED = 'succeeded';
export const ACTION_FAILED = 'failed';